import React from "react";
import Flagship from "../../core/flagship";
import { connect } from "react-redux";
import { Header, Grid } from "semantic-ui-react";
import { isEqual } from "../../utils/helpers";
import "../../styles/dashboard.scss";
import AdminFieldsField from "./AdminFieldsField";

class AdminFieldsContext extends React.Component {
  constructor(props) {
    super(props);
    this.fieldsContext = "Unknown Context";
    this.state = {
      activeFields: [],
      inactiveFields: []
    };

    this.getFields = this.getFields.bind(this);
    this.getRecordFields = this.getRecordFields.bind(this);
    this.getLineItemFields = this.getLineItemFields.bind(this);
  }

  componentWillMount() {
    setTimeout(Flagship.closeSidebarNav, 500);
    this.getFields();
  }

  componentDidMount() {
    document.title = "Flagship / Administer Fields";

    // Need to get fields list to render from API
  }

  componentWillUpdate(nextProps) {
    if (!isEqual(nextProps, this.props)) {
      this.getFields(nextProps);
    }
  }

  getFields(props = this.props) {
    let fieldsContext = "Unknown Context";

    if (props.params.splat === "client") {
      fieldsContext = "Client";
    } else if (props.params.splat === "rfp") {
      fieldsContext = "RFP";
    } else if (props.params.splat === "io") {
      fieldsContext = "IO";
    } else if (props.params.splat === "line-item") {
      fieldsContext = "Line Item (General)";
    } else if (props.params.splat === "io-product") {
      fieldsContext = "IO Product (General)";
    } else {
      let service;
      let context;
      let endpoint;

      if (props.params.splat.startsWith("line-item_")) {
        context = "RFP";
        endpoint = "line-item";
        service = props.params.splat.replace("line-item_", "");
      } else if (props.params.splat.startsWith("io-product_")) {
        context = "IO";
        endpoint = "io-product";
        service = props.params.splat.replace("io-product_", "");
      }

      Flagship.config.lineItemServices.map(function(item) {
        if (item.value === service) {
          fieldsContext = item.text;
        } else if (item.hasOwnProperty("subOptions")) {
          item.subOptions.map(function(subItem) {
            if (subItem.value === service) {
              fieldsContext = subItem.text;
            }
          });
        }
      });
      this.recordType = context;
      this.getLineItemFields(endpoint, props);
      return;
    }

    this.fieldsContext = fieldsContext;
    this.getRecordFields(props);
  }

  getLineItemFields(endpoint, props) {
    let self = this;

    Flagship.get(
      endpoint + "-form/" + props.params.splat.replace(endpoint + "_", ""),
      {
        withData: false
      },
      function(response) {
        if (response.data.success === true) {
          let activeFields = [];
          let inactiveFields = [];

          response.data.results.map(function(field) {
            if (field.active) {
              activeFields.push(field);
            } else {
              inactiveFields.push(field);
            }
          });

          self.setState({
            activeFields,
            inactiveFields
          });
        } else {
          Flagship.error(
            "Error getting fields from Flagship API server.",
            0,
            0
          );
        }
      },
      function(err) {
        Flagship.error(
          "Error getting fields from Flagship API server: " + err,
          0,
          0
        );
      }
    );
  }

  getRecordFields(props) {
    let self = this;

    Flagship.get(
      "fields/" + props.params.splat,
      {
        instance: self.props.instance
      },
      function(response) {
        if (response.data.success === true) {
          let activeFields = [];
          let inactiveFields = [];

          response.data.results.map(function(field) {
            if (field.active) {
              activeFields.push(field);
            } else {
              inactiveFields.push(field);
            }
          });

          self.setState({
            activeFields,
            inactiveFields
          });
        }
      },
      function(err) {
        Flagship.error(
          "Error getting fields to create new record: " + err,
          0,
          self.props.userId
        );
      }
    );
  }

  render() {
    if (this.props.userRole === "admin") {
      return (
        <div className="fade-in">
          <Header as="h1" className="white-text">
            Editing{" "}
            {typeof this.recordType !== "undefined" ? this.recordType : ""}{" "}
            Fields: {this.fieldsContext}
          </Header>

          <Grid>
            <Grid.Column
              mobile={16}
              tablet={8}
              computer={8}
              largeScreen={8}
              widescreen={8}
            >
              <Header as="h3" className="white-text">
                Active Fields
              </Header>
              {this.state.activeFields.length
                ? this.state.activeFields.map(function(field, i) {
                    return <AdminFieldsField {...field} key={i} />;
                  })
                : null}
            </Grid.Column>
            <Grid.Column
              mobile={16}
              tablet={8}
              computer={8}
              largeScreen={8}
              widescreen={8}
            >
              <Header as="h3" className="white-text">
                Inactive Fields
              </Header>
              {this.state.inactiveFields.length
                ? this.state.inactiveFields.map(function(field, i) {
                    return <AdminFieldsField {...field} key={i} />;
                  })
                : null}
            </Grid.Column>
          </Grid>

          <div id="footer">Flagship Administration</div>
        </div>
      );
    } else {
      return (
        <div className="fade-in">
          <Header as="h1" className="white-text">
            Administration
          </Header>
          <p className="white-text">
            You do not have access to administer Flagship.
          </p>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    token: state.main.token,
    username: state.main.username,
    firstName: state.main.userFirstName,
    userRole: state.main.userRole,
    userId: state.main.userId
  };
}

export default connect(mapStateToProps, null)(AdminFieldsContext);



// WEBPACK FOOTER //
// ./src/components/admin/AdminFieldsContext.js